<template>
  <div class="switch">
    <language-switcher-element :language-prop="'En'"/>
    /
    <language-switcher-element :language-prop="'Ru'"/>
  </div>
</template>

<script>
import LanguageSwitcherElement from "./LanguageSwitcherElement";

export default {
  name: "LanguageSwitcher",
  components: {
    LanguageSwitcherElement
  }
}
</script>

<style lang="scss" scoped>
.switch {
  width: 70px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 20px;
}

.app-dark-theme {
  .switch {
    color: #ccc;
  }
}
</style>